import { apiRequest } from "../util/apiUtils";

export const getBlogList = async (params) => {
  try {
    const res = await apiRequest("get", `/blog/list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};


export const blogAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `blog/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const blogDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `blog/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const blogStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `blog/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const blogDetails = async (params) => {
  try {
    const res = await apiRequest("get", `blog/details`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};